import React from 'react';
import './Track.css';

const Track = ({track, onAdd, onRemove, isRemoveable}) => {

    return(
        <div className="Track">
            <div className="Track-info">
                <p id="titel">{track.name}</p>
                <p>{track.artist}</p>
                <p>Album: {track.album}</p>
            </div>
            {!isRemoveable ?(
                <button onClick={() => onAdd(track)}> + </button>
                ) :(
                <button onClick={() => onRemove(track.id)}> - </button>
            )
            }
        </div>
    );
}

export default Track;